import { Component, EventEmitter, Output } from '@angular/core';
import { IconComponent } from "../../elements/icon/icon.component";
import { Icons } from "../../../model/icon";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-upload-files',
  imports: [IconComponent, NgIf],
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss'] // исправлено на styleUrls
})
export class UploadFilesComponent {
  @Output() emitFiles: EventEmitter<File[]> = new EventEmitter(); // Изменено на File[]

  protected readonly Icons = Icons;
  files: File[] = [];

  onDragOver(event: DragEvent): void {
    event.preventDefault(); // Предотвращает действие по умолчанию
    event.stopPropagation(); // Останавливает всплытие события
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleFiles(files);
    }
  }

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.handleFiles(input.files);
    }
  }

  getLabel() {
    if (this.files.length > 0) {
      return  this.files.map(v => v.name).join('\n');
    } else {
      return 'Перетащите файлы сюда или нажмите для выбора';
    }
  }

  private handleFiles(files: FileList): void {
    const fileArray: File[] = Array.from(files); // Преобразуем FileList в массив File[]
    this.files = fileArray;
    this.emitFiles.emit(fileArray); // Отправляем массив файлов в родительский компонент
  }
}
